import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';

export default function TipoPessoaPage() {
  const columns = [
    { key: 'descricao', label: 'Descrição' },
  ];

  const fields = [
    { name: 'descricao', label: 'Descrição', required: true },
  ];

  return (
    <GenericCadastroPage
      title="Tipos de Pessoa"
      description="Gerencie os tipos de classificação de pessoas."
      tableName="tipo_pessoa_v2"
      columns={columns}
      fields={fields}
    />
  );
}